// --- LES ALERTES SYSTEME ---

export function chaosNotify(message, titre = "ALERTE SYSTÈME", mode = "alert") {
    return new Promise((resolve) => {
        const modal = document.getElementById('custom-alert');
        const msgEl = document.getElementById('alert-message');
        const titleEl = document.getElementById('alert-title');
        const footer = document.getElementById('alert-buttons');

        titleEl.innerText = titre;
        msgEl.innerText = message;
        footer.innerHTML = '';

        const btnOk = document.createElement('button');
        btnOk.className = 'cyber-btn';
        btnOk.innerText = window.t('alert.ok');
        btnOk.onclick = () => {
            modal.style.display = 'none';
            resolve(true);
        };

        if (mode === "confirm") {
            const btnAnnuler = document.createElement('button');
            btnAnnuler.className = 'cyber-btn btn-alt';
            btnAnnuler.innerText = window.t('alert.cancel');
            btnAnnuler.onclick = () => {
                modal.style.display = 'none';
                resolve(false);
            };
            footer.appendChild(btnAnnuler);
        }

        footer.appendChild(btnOk);
        modal.style.display = 'flex';
    });
}

// Variante de chaosNotify avec champ de saisie texte
export function chaosInput(message, titre = "SAISIE", defaut = '') {
    return new Promise((resolve) => {
        const modal = document.getElementById('custom-alert');
        const msgEl  = document.getElementById('alert-message');
        const titleEl = document.getElementById('alert-title');
        const footer  = document.getElementById('alert-buttons');

        titleEl.innerText = titre;
        msgEl.innerHTML = '';
        const msgText = document.createElement('div');
        msgText.textContent = message;
        msgText.style.marginBottom = '10px';
        const inp = document.createElement('input');
        inp.type = 'text';
        inp.value = defaut;
        inp.maxLength = 40;
        inp.style.cssText = 'width:100%;padding:8px 10px;background:#0d1117;border:1px solid var(--theme-primary);border-radius:6px;color:#f0f6fc;font-size:0.9rem;font-family:inherit;box-sizing:border-box;outline:none;';
        msgEl.appendChild(msgText);
        msgEl.appendChild(inp);
        footer.innerHTML = '';

        const close = (val) => {
            modal.style.display = 'none';
            msgEl.innerHTML = '';
            modal.removeEventListener('keydown', onKey);
            resolve(val);
        };
        const btnOk  = document.createElement('button');
        btnOk.className = 'cyber-btn';
        btnOk.innerText = window.t('alert.ok');
        btnOk.onclick = () => close(inp.value.trim() || null);

        const btnAnnuler = document.createElement('button');
        btnAnnuler.className = 'cyber-btn btn-alt';
        btnAnnuler.innerText = window.t('alert.cancel');
        btnAnnuler.onclick = () => close(null);

        const onKey = (ev) => {
            if (ev.key === 'Enter')  { ev.preventDefault(); btnOk.click(); }
            if (ev.key === 'Escape') { ev.preventDefault(); btnAnnuler.click(); }
        };
        modal.addEventListener('keydown', onKey);

        footer.appendChild(btnAnnuler);
        footer.appendChild(btnOk);
        modal.style.display = 'flex';
        setTimeout(() => inp.focus(), 80);
    });
}

// --- NOTIFICATIONS LÉGÈRES ---
export function popToast(message, type = 'success') {
    let container = document.getElementById('chaos-toast-container');
    if (!container) {
        container = document.createElement('div');
        container.id = 'chaos-toast-container';
        container.style.position = 'fixed';
        container.style.bottom = '20px';
        container.style.right = '20px';
        container.style.zIndex = '9999';
        container.style.display = 'flex';
        container.style.flexDirection = 'column';
        container.style.gap = '10px';
        document.body.appendChild(container);
    }

    const toast = document.createElement('div');
    toast.innerText = message;
    toast.style.background = 'rgba(13, 17, 23, 0.9)';
    toast.style.color = '#c9d1d9';
    toast.style.padding = '12px 20px';
    toast.style.borderRadius = '4px';
    toast.style.boxShadow = '0 4px 12px rgba(0,0,0,0.5)';
    toast.style.fontFamily = 'monospace';
    toast.style.borderLeft = type === 'error' ? '4px solid var(--theme-danger)' : (type === 'stream' ? '4px solid var(--theme-primary)' : '4px solid var(--theme-success)');
    toast.style.transform = 'translateX(100%)';
    toast.style.transition = 'transform 0.3s ease-out, opacity 0.3s ease';
    toast.style.opacity = '0';
    
    container.appendChild(toast);
    requestAnimationFrame(() => {
        toast.style.transform = 'translateX(0)';
        toast.style.opacity = '1';
    });

    setTimeout(() => {
        toast.style.transform = 'translateX(100%)';
        toast.style.opacity = '0';
        setTimeout(() => toast.remove(), 300);
    }, 3000);
}